import React, { Component } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // This only needs to be imported once in your app
import VisibilityIcon from "@mui/icons-material/Visibility";

const images = [
  "https://www.hummingbirdresorts.com/assets/images/gallery/img41.jpg",
  "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/18/f4/ac/bf/river-forest-resort.jpg?w=700&h=-1&s=1",
  "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/18/f4/bd/fc/river-forest-resort.jpg?w=700&h=-1&s=1",
  "https://www.realestate.com.au/blog/images/1023x576-fit,progressive/2016/12/26121457/capi_7e7fb449189f6af6f35395409c4c0753_9a04263dcb6c2ff243b85085df7a4998.jpeg",
];


export default class AmenityLightBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }


  render() {
    const { photoIndex, isOpen } = this.state;

    
    return (
      <div>
        <button type="button" onClick={() => this.setState({ isOpen: true })}>
          <VisibilityIcon /> View All Images
        </button>

        {isOpen && (
          <Lightbox
            mainSrc={[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length,
              })
            }
          />
        )}
      </div>
    );
  }
}
